/** Firebase's custom action URL: every account email link lands here. */
export const AUTH_ACTION_PATH = "/auth/action";
